// extracted by mini-css-extract-plugin
export var clauseRow = "_4g-6";
export var emptyState = "_4g-b";
export var filterContent = "_4g-a";
export var filterGroup = "_4g-1";
export var filterGroupContainer = "_4g-0";
export var nestedGroup = "_4g-2";
export var nestedGroupDepth1 = "_4g-3";
export var nestedGroupDepth2 = "_4g-4";
export var nestedGroupDepth3 = "_4g-5";
export var operatorAnd = "_4g-8";
export var operatorOr = "_4g-9";
export var operatorToggle = "_4g-7";
export var removeGroupButton = "_4g-c";